import React, { useCallback } from 'react'
import classes from './SettingsTextBox.module.css'
import { useTranslation } from "react-i18next";

const SettingsTextBox = (props) => {//props=[nowSelected,setSettings,settingType,settingName,items,label]
    //translations
    const t = useTranslation('common').t;
    // let addForTranslation=''

    const setSettings = props.setSettings
    const settingType = props.settingType
    const settingName = props.settingName
    const onNewValue = useCallback(event => {
        const newText = event.target.value
        setSettings(settingType, settingName, newText)
    }, [setSettings, settingType, settingName])

    let inputElement = undefined
    if (props.type === 'textarea') {
        inputElement = <textarea id={props.id} className={classes['setting-input']} value={props.nowValue} onChange={onNewValue} />
    }
    else {
        inputElement = <input id={props.id} className={classes['setting-input']} value={props.nowValue} onChange={onNewValue} type={props.type} />
    }

    return (
        <div className={`${classes['settings-container']} ${props.className ? props.className : ''}`}>
            <label htmlFor={props.id} className={classes['setting-input-label']}>{t(props.label)} </label>
            {inputElement}
            {props.detailsLabel && <p className={classes['input-details']}>{t(props.detailsLabel)}</p>}
        </div>
    )
}

export default SettingsTextBox